import React from 'react';
import './Process.css';

function Process() {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Planning',
      description: 'We begin by understanding your vision, target audience, and business goals. Through detailed discussions, we map out features, timelines, and project scope.',
      icon: '🎯'
    },
    {
      number: '02',
      title: 'Design & Prototyping',
      description: 'Our designers create beautiful, intuitive interfaces tailored to your brand. You\'ll see interactive prototypes before any code is written.',
      icon: '✨'
    },
    {
      number: '03',
      title: 'Development',
      description: 'Our expert developers bring designs to life using the latest technologies. We follow agile practices with regular updates and demos throughout.',
      icon: '⚙️'
    },
    {
      number: '04',
      title: 'Testing & Quality',
      description: 'Rigorous testing across devices and scenarios ensures your app is bug-free, performant, and delivers an exceptional user experience.',
      icon: '🔍'
    },
    {
      number: '05',
      title: 'Launch & Deploy',
      description: 'We handle the entire deployment process, from app store submissions to server configuration, ensuring a smooth and successful launch.',
      icon: '🚀'
    },
    {
      number: '06',
      title: 'Support & Growth',
      description: 'Post-launch, we provide ongoing maintenance, monitor performance, and help you scale with new features and improvements.',
      icon: '📈'
    }
  ];

  return (
    <section id="process" className="process">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Process</h2>
          <p className="section-subtitle">
            A proven methodology that transforms ideas into successful applications. 
            Clear, transparent, and collaborative every step of the way.
          </p>
        </div>

        <div className="process-timeline">
          {steps.map((step, index) => (
            <div className="process-step" key={index} style={{ animationDelay: `${index * 0.15}s` }}>
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>

        <div className="process-cta">
          <div className="cta-box">
            <h3 className="cta-title">Ready to Start Your Project?</h3>
            <p className="cta-text">
              Let's discuss your requirements and create something amazing together. 
              Get a free consultation and project estimate today.
            </p>
            <button 
              className="cta-button-large"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
